/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryResourceDetailsResponse {
    getFixupPrototypeFunction() { return InventoryResourceDetailsResponse.fixupPrototype; }

    static newInstance(model: Partial<InventoryResourceDetailsResponse>): InventoryResourceDetailsResponse {
        let obj = Object.assign(new InventoryResourceDetailsResponse(), model);
        InventoryResourceDetailsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryResourceDetailsResponse>): InventoryResourceDetailsResponse {
        if (!model) return null;
        return InventoryResourceDetailsResponse.newInstance(<InventoryResourceDetailsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryResourceDetailsResponse) {
        if (!obj) return;

        models.InventoryResourceDetailsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryResourceDetailsResponse): boolean {
        Object.setPrototypeOf(obj, InventoryResourceDetailsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource_details) {
            for (let val of this.resource_details) {
                models.InventoryResourceDetailsModelList.fixupPrototype(val);
            }
        }
    }

    /**
     * Inventory summary details
     */
    count: string;

    /**
     * Inventory summary details
     */
    resource_details: Array<models.InventoryResourceDetailsModelList>;

}
